"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var React = require("react");
var ManagedFormInput = (function (_super) {
    __extends(ManagedFormInput, _super);
    function ManagedFormInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: _this.props.value || ""
        };
        return _this;
    }
    ManagedFormInput.prototype.render = function () {
        return (React.createElement("input", __assign({}, this.props, { onChange: this.onInput.bind(this), value: this.state.currentValue })));
    };
    ManagedFormInput.prototype.onInput = function (event) {
        if (this.props.type === "radio" || this.props.type === "checkbox") {
            this.props.onChange();
        }
        else {
            this.setState({
                currentValue: event.target.value
            });
        }
    };
    return ManagedFormInput;
}(React.Component));
exports.ManagedFormInput = ManagedFormInput;
;

//# sourceMappingURL=ManagedFormInput.js.map



//////////////////
// WEBPACK FOOTER
// ./~/framework7-react/dist/src/components/inputs/ManagedFormInput.js
// module id = 231
// module chunks = 0